var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-102",
    "class": {
      'not-active-cloud': !_vm.object.cloudMeta._.clouds[0].isActive
    }
  }, [_c('div', {
    staticClass: "div-block-104"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": _vm.object.image,
      "loading": "lazy"
    }
  }), _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.object.label))])]), _vm.object.subField ? _c('div', {
    staticClass: "input-block contrast"
  }, [_c('div', {
    staticClass: "div-block-101"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.object.subLabel) + " ")]), _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.object.subValue)) + " EUR")])])]) : _vm._e(), _c('div', {
    staticClass: "horizontal-diveder"
  }), _vm._l(_vm.object.missingFiles, function (missingFile, index) {
    return _c('document-cloud-handler', {
      key: index + 'cldmis',
      attrs: {
        "title": missingFile.name,
        "type": missingFile.id,
        "uploaded": missingFile.uploaded,
        "class-cst": 'upload-item-broker-custom',
        "cloud-meta": _vm.object.cloudMeta,
        "rules": ['priority'],
        "allow-unassign": "",
        "text-button": ""
      }
    });
  }), _c('div', {
    staticClass: "horizontal-diveder"
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }